import {Component} from "@angular/core";
import {UNITYTinyMCE} from "./tinymce/unity-tinymce.ts";

@Component({
    selector: 'under-construction',
    template: `
      <h3>Seleccione un item del menu</h3>
      <unity-tinymce [mceContent]="content" (contentChanged)="contentChanged($event)"></unity-tinymce>
    `,
    directives: [UNITYTinyMCE]
})
export class UnderConstruction {

    private content:string;

    constructor() {
    }

    public contentChanged(event:any):void {
        console.log(event);
    }
}


/** WEBPACK FOOTER **
 ** ./src/app/under.construction.component.ts
 **/